export default "__VITE_ASSET__Bvp8xHmQ__"